const topics = [
  { name: '庆余年3', heat: '9.8万', tag: '热门', accent: true },
  { name: '狂飙', heat: '9.5万', tag: '经典', accent: false },
  { name: '眼泪女王', heat: '9.1万', tag: '新番', accent: true },
  { name: '三体', heat: '8.9万', tag: '科幻', accent: false },
  { name: '玫瑰的故事', heat: '8.5万', tag: '都市', accent: false },
  { name: '黑暗荣耀', heat: '8.3万', tag: '悬疑', accent: false },
  { name: '长相思', heat: '7.8万', tag: '古装', accent: false },
  { name: '唐朝诡事录', heat: '7.5万', tag: '探案', accent: false },
  { name: '与恶魔有约', heat: '7.2万', tag: '奇幻', accent: true },
  { name: '权力的游戏', heat: '6.8万', tag: '史诗', accent: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-50 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-8">
          热门话题
        </h2>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, i) => (
            <a
              key={i}
              href={`#index`}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap border ${
                topic.accent
                  ? 'bg-accent-50 text-accent-800 border-accent-200 hover:bg-accent-100'
                  : 'bg-secondary-50 text-secondary-700 border-secondary-200 hover:bg-secondary-100'
              }`}
            >
              <span>{topic.name}</span>
              <span className={`text-xs px-1.5 py-0.5 rounded-full ${
                topic.accent ? 'bg-accent-200 text-accent-700' : 'bg-secondary-200 text-secondary-600'
              }`}>
                {topic.heat}
              </span>
              <span className={`text-[10px] px-1.5 py-0.5 rounded ${
                topic.accent ? 'bg-accent-500 text-background-50' : 'bg-secondary-400 text-background-50'
              }`}>
                {topic.tag}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}